export default __webpack_public_path__ + "static/media/RatsamyPathammavong.bbddbd45.png";